import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: "https://Urdoerapi.el.r.appspot.com/",
});